// extracted by mini-css-extract-plugin
export default {"box":"box_box__nfEEy","box__body":"box_box__body__Wgz4M"};